import {handleResponse} from './responseMixed';
import {PAGE_LOADER_DELAY_MS} from '../constants/constants';
import {toast, removeLoaderToast} from '../../../components/kui/toast/toast';

const showLoader = () => {
    document.documentElement.classList.add('is-loading');
    toast({message: 'Loading', type: 'loader'});
};

const clearLoaderTimeout = (timeout, hasTimeout = true) => {
    clearTimeout(timeout);

    if (hasTimeout) {
        // NOTE: Add a deliberate delay to comprehend the spinner
        setTimeout(removeLoaderToast, 200);
    } else {
        removeLoaderToast();
    }
};

const getContextObject = (path) => {
    const str = path && path.split('/')[3];

    const obj = {};

    if (str) {
        const params = str
            .split(':')
            .filter((i) => i)
            .join('&')
            .split('&');

        for (let i = 0; i < params.length; i = i + 2) {
            obj[params[i]] = params[i + 1];
        }
    }

    return obj;
};

let controller;
let loaderTimeout;

export const fetchPath = async (state, isPushState) => {
    const oldContext = getContextObject(state.from);
    const newContext = getContextObject(state.path);
    const csrfToken = document.head.querySelector(
        '[name=csrf-token][content]'
    ).content;

    const setupLoader = () =>
        (loaderTimeout = setTimeout(showLoader, PAGE_LOADER_DELAY_MS));

    try {
        setupLoader();

        if (controller) {
            controller.abort();
        }

        controller = new AbortController();

        const response = await fetch(state.path, {
            method: 'get',
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken
            },
            signal: controller.signal
        });

        const root = await handleResponse(response, newContext, oldContext);

        if (state.path.includes('#')) {
            window.location = state.path;
        }

        clearLoaderTimeout(loaderTimeout);

        if (root) {
            const newState = {path: state.path};

            if (isPushState && !response.headers.get('x-intra-redirect')) {
                history.pushState(newState, '', state.path);
            }
        }
    } catch (err) {
        if (err.name == 'AbortError') {
            clearLoaderTimeout(loaderTimeout, false);
        } else {
            console.error(err);
        }
    }
};

const stateFetch = async () => {
    const path = window.location.pathname + window.location.search;

    history.replaceState({path: path, title: document.title}, '', path);

    window.addEventListener('popstate', (popStateEvent) => {
        if (!popStateEvent.state) {
            return;
        }

        setTimeout(() => {
            fetchPath(popStateEvent.state, false);
        }, 0);

        return true;
    });
};

export default stateFetch;
